import { render, staticRenderFns } from "./CatchingAttributes.vue?vue&type=template&id=16f39456&scoped=true&"
import script from "./CatchingAttributes.vue?vue&type=script&lang=js&"
export * from "./CatchingAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f39456",
  null
  
)

export default component.exports